import React, { Fragment, useCallback, useEffect, useMemo, useRef, useState } from "react";
import { ReactComponent as Building } from "../../../../assets/utils/images/svgs/building.svg";
import { ReactComponent as FourLines } from "../../../../assets/utils/images/svgs/FourHorLine.svg";
import { ReactComponent as AfasIcon } from "../../../../assets/utils/images/svgs/AfasSoftware.svg";
import { ReactComponent as AddIcon } from "../../../../assets/utils/images/svgs/addBlue.svg";
import { Button, CardFooter, Modal, ModalBody, ModalFooter, ModalHeader, FormGroup, Form, Label, Input } from 'reactstrap';
import Algemeen from "./Algemeen"
import PageHeading from "Layout/AppMain/PageHeading";
import { useLocation, useNavigate, useParams } from "react-router";
import { userTabs } from "./utils";
import Scholen from "./Scholen";
import VrijeVelden from "./VrijeVelden";
import AfasKoppeling, {
    emptyValues as emptyAfasFormValues,
    isAfasMandatoryComplete,
    resolveConnectorSwitchValue,
} from "./AfasKoppeling";
import { ErrorMessage, Formik } from "formik";
import { toast } from "react-toastify";
import { debounce } from "helperFunctions";
import { DropdownList } from "react-widgets/cjs";
import TransitionOnLoad from "Components/TransitionOnLoad";
import ReporterModal from "Pages/Coordinator/Instellingen/Besturen/BesturenView/ReporterModal";
import AfasGebruikerModal from "./Algemeen/AfasGebruikerModal";
import { useBestuur, useCoordinators, useDeleteBestuur, useReporterAddRemove, useReporters, useSaveFreeFields, useSaveSchool, useSchools, useSearchBesturen, useUpdateBestuur, useUpdateSchool } from "Api/Admin/Besturen";
import { useAfasConnection, useSaveAfasConnection } from "Api/Admin/Besturen/AfasKoppeling";
import {
    useAfasGebruikers,
    useAddAfasGebruiker,
    useRemoveAfasGebruiker,
} from "Api/Admin/Besturen/AfasGebruikers";
import AuthService from "Api/Auth";
import { useDispatch } from "react-redux";
import { setUserRole } from "reducers/UserPermission";

const validationRules = {
    Website: {
        pattern: /^(https?:\/\/)?([\w-]+(\.[\w-]+)+.*)$/i,
        errorMessage: "Ongeldige website-URL"
    },
};

const Besturens = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [activeTab, setActiveTab] = useState(userTabs.Algemeen);
    const [communityLists, setCommunityLists] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [disableModalSubmitButton, setDisableModalSubmitButton] = useState(true);
    const [modalData, setModalData] = useState({ type: '', data: {} })
    const [errorField, setErrorField] = useState('');
    const [isdataDelete, setDataDelete] = useState(false);
    const [editSelectedRow, setEditSelectedRow] = useState(null);
    const [pageSizeCount, setPageSizeCount] = useState(20);
    const [pageNumber, setPageNumber] = useState(1);
    const [searchValue, setSearchValue] = useState('');
    const [searchCommunityLists, setSearchCommunityLists] = useState([]);
    const [openSearchModal, setOpenSearchModal] = useState(false);
    const [openAfasSearchModal, setOpenAfasSearchModal] = useState({
        type: 'add',
        state: false,
    });

    const { communityList } = location.state || {};
    const { id } = useParams();

    const [communityId, setCommunityId] = useState(id);

    // Keep local id in sync when URL changes (list click, footer select, refresh).
    useEffect(() => {
        if (id != null) {
            setCommunityId(id);
        }
    }, [id]);
    const [formData, setFormData] = useState({
        inputField1: "",
        inputField2: "",
        inputField3: "",
        inputType1: "",
        inputType2: "",
        inputType3: "",
        useSalaryColumn: false
    });
    const [disableSubmit, setDisableSubmit] = useState(true);
    const [afasFormData, setAfasFormData] = useState(emptyAfasFormValues);
    const afasFormDataRef = useRef(afasFormData);
    afasFormDataRef.current = afasFormData;
    const afasConnectionDataRef = useRef({});
    const communityIdRef = useRef(communityId);
    communityIdRef.current = communityId;
    const { trigger: saveSchoolMutation } = useSaveSchool();
    const { trigger: updateSchoolMutation } = useUpdateSchool();
    const { trigger: updateBestuurMutation } = useUpdateBestuur();
    const { trigger: deleteBestuurMutation } = useDeleteBestuur()
    const { trigger: saveFreeFieldsMutation } = useSaveFreeFields();
    const { trigger: saveAfasConnectionMutation } = useSaveAfasConnection();
    const { trigger: reporterAddRemoveTrigger } = useReporterAddRemove();

    const {
        data: bestuurResponse,
        isLoading, mutate: mutateBestuur
    } = useBestuur(communityId);
    // Memoized so the `{}` fallback keeps one identity while the request is in
    // flight. A fresh object per render re-fires the effects below on every
    // render, and that loop exhausts React's update-depth limit before the
    // response lands, which unmounts the app (error #185).
    const viewData = useMemo(() => bestuurResponse?.data || {}, [bestuurResponse]);

    const {
        data: afasConnectionResponse,
        isLoading: afasConnectionLoading,
        mutate: mutateAfasConnection,
    } = useAfasConnection(
        activeTab === userTabs.AfasKoppeling ? communityId : null
    );

    const afasConnectionData = useMemo(
        () => afasConnectionResponse?.data || {},
        [afasConnectionResponse],
    );
    afasConnectionDataRef.current = afasConnectionData;

    useEffect(() => {
        if (!afasConnectionData?.iCommunityId) {
            return;
        }

        const mandatoryComplete = isAfasMandatoryComplete(
            afasConnectionData,
            afasConnectionData,
        );

        // Existing AFAS links: keep DB connector flags as-is.
        // Empty / incomplete forms only: default switches to off in the UI.
        setAfasFormData({
            environment: afasConnectionData.environment ?? "",
            configured_on_environment:
                afasConnectionData.configured_on_environment ?? "",
            token: afasConnectionData.token ?? "",
            clooser_verzoek_guid: afasConnectionData.clooser_verzoek_guid ?? "",
            clooser_regel_guid: afasConnectionData.clooser_regel_guid ?? "",
            werkgever_id: afasConnectionData.werkgever_id ?? "",
            werkgever_naam: afasConnectionData.werkgever_naam ?? "",
            get_connectors_enabled: resolveConnectorSwitchValue(
                afasConnectionData.get_connectors_enabled,
                mandatoryComplete,
            ),
            update_connectors_enabled: resolveConnectorSwitchValue(
                afasConnectionData.update_connectors_enabled,
                mandatoryComplete,
            ),
        });
    }, [afasConnectionData]);

    useEffect(() => {
        setFormData({
            inputField1: viewData?.inputField1 || "",
            inputField2: viewData?.inputField2 || "",
            inputField3: viewData?.inputField3 || "",
            inputType1: viewData?.inputType1 || "",
            inputType2: viewData?.inputType2 || "",
            inputType3: viewData?.inputType3 || "",
            useSalaryColumn: viewData?.useSalaryColumn || false
        });
    }, [viewData]);

    const {
        data: schoolResponse,
        isLoading: schoolLoading,
        mutate: mutateSchools
    } = useSchools(
        communityId,
        pageSizeCount,
        pageNumber,
        searchValue
    );

    const schoolTableData =
        schoolResponse?.data?.schoolLists || [];

    const totalPageCount =
        schoolResponse?.data?.paginate || 0;
    const totalCount = schoolResponse?.data?.totalCount;
    useEffect(() => {
        setCommunityLists(Array.isArray(communityList) ? communityList : []);
    }, [communityList]);

    const indexPageSize = (val) => {
        setPageSizeCount(val);
    };

    const functieTablePageSize = (val) => {
        setPageNumber(1);
        indexPageSize(val);
    };

    const userTablePageSize = (val) => {
        setPageNumber(1);
        indexPageSize(val);
    }

    const paginate = (val) => {
        setPageNumber(val);
    };

    const getActiveTab = (tabState) => {
        switch (tabState) {
            case userTabs.Algemeen:
                return <Algemeen coordinatorData={coordinatorData} mutateReporter={mutateReporter} addOrDeleteMelderHandler={addOrDeleteMelderHandler} setCommunityId={setCommunityId} communityId={communityId} mutateBestuur={mutateBestuur} data={viewData} communityList={communityList} isLoading={CoordinatorLoading} setOpenModal={setOpenModal} setModalData={setModalData} handleFieldChange={handleFieldChange} handleIconFieldChange={handleIconFieldChange} isdataDelete={isdataDelete} setDataDelete={setDataDelete} afasUsers={afasUsers} onRemoveAfasUser={removeAfasUserHandler} />
            case userTabs.Scholen:
                return <Scholen tableData={schoolTableData} handleSchoolClick={handleSchoolClick} setCommunityId={setCommunityId} communityId={communityId} searchValue={searchValue} communityList={communityList} setSearchValue={setSearchValue} pageNumber={pageNumber} setPageNumber={setPageNumber} paginate={paginate} userTablePageSize={userTablePageSize} functieTablePageSize={functieTablePageSize} setPageSizeCount={setPageSizeCount} totalPageCount={totalPageCount} toggle={toggle} showLoader={schoolLoading} pageSizeCount={pageSizeCount} editSelectedRow={editSelectedRow} setEditSelectedRow={setEditSelectedRow} data={viewData} isLoading={isLoading} setOpenModal={setOpenModal} setModalData={setModalData} mutateSchools={mutateSchools} totalCount={totalCount} />
            case userTabs.VrijeVelden:
                return <VrijeVelden data={viewData} setFormData={setFormData} setCommunityId={setCommunityId} communityId={communityId} isLoading={isLoading} communityList={communityList} callApi={callApi} />
            case userTabs.AfasKoppeling:
                return (
                    <AfasKoppeling
                        isLoading={afasConnectionLoading}
                        connectionData={afasConnectionData}
                        communityId={communityId}
                        onFieldChange={handleAfasFieldChange}
                    />
                );

            default:
                break;
        }
    }

    const isActiveTab = (currentTab) => {
        return activeTab === currentTab
    }

    const toggle = () => {
        setOpenModal(false);
        setDataDelete && setDataDelete(false);
        setDisableModalSubmitButton(true);
        setTimeout(() => {
            setModalData({ type: '', data: {} });
        }, 500);
    }


    const modalFormSubmitHandler = () => {
        if (modalData?.type === "schoolSave") {

            saveSchoolMutation({
                data: {

                    iCommunityId: viewData?.iCommunityId,
                    vSchoolName: modalData?.data?.vSchoolName,
                    eStatus: "Active"
                }

            }).then((response) => {

                if (response?.status) {
                    toggle();
                    mutateSchools();
                } else {
                    toast.error("Kan niet opslaan.");
                    toggle();
                }
            }).catch((error) => {
                toggle();
                console.error(error);
                toast.error("Er is iets misgegaan");
            })
        } else if (modalData?.type === "schoolUpdate") {

            updateSchoolMutation({
                iCommunityId: viewData?.iCommunityId,
                vSchoolName: modalData?.vSchoolName,
                iSchoolId: modalData?.iSchoolId
            }).then((response) => {
                if (response?.status) {
                    toggle();
                    mutateSchools();
                } else {
                    toast.error("Kan niet updaten.");
                }
            }).catch((error) => {
                console.error(error);
                toast.error("Er is iets misgegaan");
                toggle();
            })
        }
        else {
            deleteBestuurMutation(`/${viewData.iCommunityId}`).then((response) => {
                if (response?.status) {
                    toggle();
                    navigate('/beheerder/besturen')
                } else {
                    toggle();
                    toast.error("Kan niet verwijderen.");
                }
            }).catch((error) => {
                toggle();
                console.error(error);
                toast.error("Kan niet verwijderen.");
            })
        }
    };

    const callApi = (field, value, setFieldError = () => { }, errorField = "") => {

        if (viewData[field] === value || (viewData[field] === null && value === "")) {
            toast.dismiss();
            // if (viewData[field] === value) toast.error("Geen wijzigingen gedetecteerd.");
            return;
        }

        if (errorField === 'Website' && value !== "") {
            const rule = validationRules[errorField];

            if (rule && !rule.pattern.test(value)) {
                setFieldError?.(field, rule.errorMessage);
                toast.dismiss();
                toast.error(rule.errorMessage);
                return;
            }
        }

        if (field === "vCommunityName" && value === "") {
            setFieldError?.(field, "Naam bestuur is vereist");
            return;
        }


        const apiData = {
            iCommunityId: parseInt(communityId),
            ...(field ? { attr: field } : {}),
            [field]: value,
        }
        updateBestuurMutation({
            data: apiData, method: 'put'
        })
            .then(response => {
                if (response?.status) {
                    mutateBestuur();
                    toast.dismiss();
                    toast.success("Wijzigingen opgeslagen.");
                    return
                };
                if (!response?.status) {
                    setErrorField(field);
                    const errors = response.data[field];
                    if (Array.isArray(errors)) {
                        toast.error(errors.join(','));
                    } else {
                        toast.error(errors);
                    }
                }
            })
            .catch(error => {
                console.error('API error:', error);
                toast.dismiss();
                toast.error("serverfout")
            })
    };

    // Stable debounce — recreating each render leaves orphaned timers.
    const callApiRef = useRef(callApi);
    callApiRef.current = callApi;
    const debouncedApiCall = useMemo(
        () => debounce((...args) => callApiRef.current(...args), 700),
        [],
    );

    const handleFieldChange = (field, value, setFieldError = () => { }, errorField = "") => {
        debouncedApiCall(field, value, setFieldError, errorField);
    };

    const handleIconFieldChange = (field, value, setFieldError = () => { }) => {
        setFieldError = () => { }
        callApi(field, value);
    };

    const handleSchoolClick = (from, data = null) => {
        if (from === "save") {
            setOpenModal(true);
            setModalData({ type: 'schoolSave', data: {} });
        } else {
            setOpenModal(true);
            setModalData({ type: 'schoolUpdate', data: data });
        }
    }

    const isFormChanged = () => {
        return JSON.stringify(formData) !== JSON.stringify({
            inputField1: viewData?.inputField1,
            inputField2: viewData?.inputField2,
            inputField3: viewData?.inputField3,
            inputType1: viewData?.inputType1,
            inputType2: viewData?.inputType2,
            inputType3: viewData?.inputType3,
            useSalaryColumn: viewData?.useSalaryColumn
        });
    };

    useEffect(() => {
        setDisableSubmit(!isFormChanged());
    }, [formData, viewData]);

    const persistAfasConnection = useCallback(() => {
        const currentCommunityId = communityIdRef.current;
        const data = afasFormDataRef.current;
        const connection = afasConnectionDataRef.current;

        if (!currentCommunityId) {
            return;
        }

        if (!String(data.environment || "").trim() || !String(data.werkgever_id || "").trim()) {
            return;
        }

        const hasExistingToken = Boolean(connection?.has_token);
        if (!hasExistingToken && !String(data.token || "").trim()) {
            return;
        }

        // Never force connector flags off for existing links.
        // Save only what is already in form state (loaded from DB or user toggle).
        saveAfasConnectionMutation({
            data: {
                iCommunityId: parseInt(currentCommunityId, 10),
                ...data,
            },
        })
            .then((response) => {
                if (response?.status) {
                    mutateAfasConnection();
                    toast.success(
                        "Bijgewerkt! De AFAS-koppeling is succesvol opgeslagen."
                    );
                    return;
                }

                toast.dismiss();
                toast.error(
                    response?.message ||
                    "Fout bij het bijwerken! Probeer het opnieuw."
                );
            })
            .catch((error) => {
                console.error("API error:", error);
                toast.dismiss();
                toast.error("Fout bij het bijwerken! Probeer het opnieuw.");
            });
    }, [mutateAfasConnection, saveAfasConnectionMutation]);

    const persistAfasConnectionRef = useRef(persistAfasConnection);
    persistAfasConnectionRef.current = persistAfasConnection;
    const debouncedAfasSave = useMemo(
        () => debounce(() => persistAfasConnectionRef.current(), 700),
        [],
    );

    const handleAfasFieldChange = (field, value) => {
        setAfasFormData((prev) => {
            const next = {
                ...prev,
                [field]: value,
            };
            afasFormDataRef.current = next;
            return next;
        });
        debouncedAfasSave();
    };

    const handleSubmitForm = () => {
        setDisableSubmit(true)
        const apiData = {
            iCommunityId: viewData?.iCommunityId,
            ...formData,
        }
        saveFreeFieldsMutation({
            data: apiData,
        })
            .then(response => {
                if (response?.status) {
                    mutateBestuur();
                    toast.success("Bijgewerkt! De wijzigingen zijn succesvol opgeslagen.")
                } else {
                    setDisableSubmit(false)
                    toast.dismiss();
                    toast.error("Fout bij het bijwerken! Probeer het opnieuw.")
                }
            })
            .catch(error => {
                setDisableSubmit(false)
                console.error('API error:', error);
                toast.dismiss();
                toast.error("Fout bij het bijwerken! Probeer het opnieuw.")
            })
    }

    const shouldSearch =
        searchValue &&
        !communityList?.some((item) => {
            const labelMatch = item.label
                ?.toLowerCase()
                .includes(searchValue.toLowerCase());

            const valueMatch = String(item.value)
                ?.toLowerCase()
                .includes(searchValue.toLowerCase());

            return labelMatch || valueMatch;
        });

    const { data: searchResponse } =
        useSearchBesturen(
            shouldSearch ? searchValue : null
        );

    useEffect(() => {
        if (searchResponse?.status) {
            setSearchCommunityLists(
                searchResponse?.communitiesLists.map((item) => ({
                    value: item.iCommunityId,
                    label: item.vCommunityName,
                }))
            );
        }
    }, [searchResponse]);

    const fetchCommunitySearch = (searchTerm) => {
        setSearchValue(searchTerm);
    };

    const handleCommunityChange = (selectedValue) => {
        const nextId = selectedValue;
        setCommunityId(nextId);
        setSearchCommunityLists([]);
        setCommunityLists((prev) => {
            const updatedList = Array.isArray(prev) ? [...prev] : [];
            if (updatedList.length > 0) {
                updatedList.pop();
            }

            const selectedCommunity = searchCommunityLists.find(
                (item) => item.value === parseInt(selectedValue, 10),
            );
            if (selectedCommunity) {
                updatedList.unshift(selectedCommunity);
            }

            return updatedList;
        });
        navigate(`/beheerder/besturen/${nextId}`, {
            replace: true,
            state: {
                communityList: Array.isArray(communityLists) ? communityLists : [],
            },
        });
    };

    const {
        data: coordinatorResponse,
        isLoading: CoordinatorLoading,
        mutate: mutateCoordinator,
    } = useCoordinators(communityId || null);

    const coordinatorData = useMemo(
        () => coordinatorResponse?.data || [],
        [coordinatorResponse],
    );


    const addOrDeleteMelderHandler = async (type, iAdminId) => {
        const data = {
            iAdminId,
            iCommunityId: communityId,
            type
        }
        reporterAddRemoveTrigger({
            data,
        })
            .then((response) => {
                if (response?.status) {
                    setOpenSearchModal(false);
                    setTimeout(() => {
                        mutateCoordinator();
                    }, 1000);

                    mutateReporter();
                }
            })
    }

    const {
        data: reporterResponse,
        isLoading: isReporterLoading,
        mutate: mutateReporter,
    } = useReporters(communityId || null);

    const reporterData =
        reporterResponse?.data || [];

    const {
        data: afasUsersResponse,
        isLoading: isAfasUsersLoading,
        mutate: mutateAfasUsers,
    } = useAfasGebruikers(communityId || null);

    const afasUsers = useMemo(
        () => afasUsersResponse?.data || [],
        [afasUsersResponse],
    );
    const { trigger: addAfasGebruikerTrigger } = useAddAfasGebruiker();
    const { trigger: removeAfasGebruikerTrigger } = useRemoveAfasGebruiker();

    // Salaris allowlist candidates = all organisation users (admin_community + coordinators),
    // not yet allowlisted. Skip empty names and entries without a role source.
    const afasCandidateUsers = useMemo(() => {
        const hasUsableName = (candidate) => {
            const meaningful = String(candidate?.name ?? '')
                .trim()
                .replace(/[,\s]+/g, '');
            return meaningful.length > 0;
        };

        const byId = new Map();
        const addCandidate = (candidate, role) => {
            const id = Number(candidate?.iAdminId);
            if (!Number.isFinite(id) || id <= 0 || byId.has(id)) {
                return;
            }
            if (!hasUsableName(candidate) || !role) {
                return;
            }
            byId.set(id, { ...candidate, role });
        };

        coordinatorData.forEach((candidate) => addCandidate(candidate, 'coordinator'));
        reporterData.forEach((candidate) => addCandidate(candidate, 'gebruiker'));

        return Array.from(byId.values())
            .filter(
                (candidate) =>
                    !afasUsers.some(
                        (user) => Number(user.iAdminId) === Number(candidate.iAdminId),
                    ),
            )
            .sort((a, b) =>
                String(a?.name || '').localeCompare(String(b?.name || ''), 'nl', {
                    sensitivity: 'base',
                }),
            );
    }, [coordinatorData, reporterData, afasUsers]);

    const isAlgemeenTab = activeTab === userTabs.Algemeen;

    const addAfasUserHandler = async (iAdminId) => {
        try {
            const response = await addAfasGebruikerTrigger({
                data: {
                    iAdminId,
                    iCommunityId: communityId,
                },
            });
            if (response?.status) {
                setOpenAfasSearchModal({ type: 'add', state: false });
                mutateAfasUsers();
                const nextRoles = AuthService.syncCurrentUserAfasRole(
                    iAdminId,
                    response.canAccessAfas ?? true,
                );
                if (nextRoles) {
                    dispatch(setUserRole(nextRoles));
                }
                toast.success('AFAS gebruiker toegevoegd');
            }
        } catch (error) {
            toast.error(error?.message || 'Toevoegen mislukt');
        }
    };

    const removeAfasUserHandler = async (iAdminId) => {
        try {
            const response = await removeAfasGebruikerTrigger({
                data: {
                    iAdminId,
                    iCommunityId: communityId,
                },
            });
            if (response?.status) {
                mutateAfasUsers();
                const nextRoles = AuthService.syncCurrentUserAfasRole(
                    iAdminId,
                    response.canAccessAfas ?? false,
                );
                if (nextRoles) {
                    dispatch(setUserRole(nextRoles));
                }
                toast.success('AFAS gebruiker verwijderd');
            }
        } catch (error) {
            toast.error(error?.message || 'Verwijderen mislukt');
        }
    };

    return (
        <Fragment>
            <div className="besturen-view contract-typen-view">
                <PageHeading />
                <TransitionOnLoad>
                    <Fragment>
                        <div className="d-flex gap-4" style={{ marginBottom: `${activeTab === userTabs.Urenoverzicht || activeTab === userTabs.Beschikbaarheid ? '50px' : '20px'}` }}>
                            <div className={activeTab === userTabs.Beschikbaarheid ? "w-auto user-ctn col" : " user-ctn w-auto col"}>
                                {getActiveTab(activeTab)}

                            </div>
                            {
                                activeTab !== userTabs.Beschikbaarheid &&
                                <div className="users-tab">
                                    <p className={isActiveTab(userTabs.Algemeen) ? 'active' : ''} onClick={() => { setActiveTab(userTabs.Algemeen) }}><i className="metismenu-icon pe-7s-home" style={{ fontSize: '24px' }}></i>Algemeen</p>
                                    <p className={isActiveTab(userTabs.Scholen) ? 'active' : ''} onClick={() => { setActiveTab(userTabs.Scholen); }}><Building style={{ width: '22px', height: '24px' }} />Scholen</p>
                                    <p className={isActiveTab(userTabs.VrijeVelden) ? 'active' : ''} onClick={() => { setActiveTab(userTabs.VrijeVelden); }}><FourLines style={{ width: '22px', height: '24px' }} />Vrije Velden</p>
                                    <p className={isActiveTab(userTabs.AfasKoppeling) ? 'active' : ''} onClick={() => { setActiveTab(userTabs.AfasKoppeling); }}><AfasIcon style={{ width: '22px', height: '24px' }} />Afas-Koppeling</p>
                                </div>
                            }
                        </div>

                    </Fragment>
                </TransitionOnLoad>
                <div className="chat-layout-footer verzoken-footer-height besturen-footer-bar">
                    <CardFooter className="chat-layout-footer__inner">
                        <div className="d-flex align-items-center w-100">
                            {/* Left Side */}
                            <div className="d-flex align-items-center gap-3">
                                <DropdownList
                                    dataKey="value"
                                    textField="label"
                                    placeholder="Selecteer"
                                    onChange={(e) => handleCommunityChange(e.value)}
                                    name="communityIds"
                                    value={
                                        communityLists?.find(
                                            (item) => item.value === parseInt(communityId)
                                        ) || viewData?.vCommunityName
                                    }
                                    data={
                                        (searchCommunityLists?.length > 0
                                            ? searchCommunityLists
                                            : communityLists) || []
                                    }
                                    onSearch={(searchTerm) => fetchCommunitySearch(searchTerm)}
                                    dropUp
                                    onBlur={() => setSearchCommunityLists([])}
                                    filter={(item, searchTerm) => {
                                        const labelMatch = item.label
                                            ?.toLowerCase()
                                            .includes(searchTerm.toLowerCase());
                                        const valueMatch = String(item.value)
                                            ?.toLowerCase()
                                            .includes(searchTerm.toLowerCase());
                                        return labelMatch || valueMatch;
                                    }}
                                />

                                {isAlgemeenTab && (
                                    <Button
                                        outline
                                        className="btn-outline-primary-blue btn-color-style besturen-footer-btn d-flex gap-2 align-items-center"
                                        type="button"
                                        color="primary"
                                        onClick={() => {
                                            setOpenSearchModal({ type: "add", state: true });
                                        }}
                                    >
                                        Coordinator <AddIcon />
                                    </Button>
                                )}

                                {isAlgemeenTab && (
                                    <Button
                                        outline
                                        className="btn-outline-primary-blue btn-color-style besturen-footer-btn d-flex gap-2 align-items-center"
                                        type="button"
                                        color="primary"
                                        onClick={() => {
                                            setOpenAfasSearchModal({ type: "add", state: true });
                                        }}
                                    >
                                        Salaris gebruiker <AddIcon />
                                    </Button>
                                )}

                                {activeTab === userTabs?.Scholen && (
                                    <Button
                                        outline
                                        className="btn-outline-primary-blue btn-color-style besturen-footer-btn d-flex gap-2 align-items-center"
                                        onClick={() => handleSchoolClick("save")}
                                        type="button"
                                        color="primary"
                                    >
                                        School <AddIcon />
                                    </Button>
                                )}

                                {openSearchModal?.state && (
                                    <ReporterModal
                                        setModal={setOpenSearchModal}
                                        modal={openSearchModal}
                                        addOrDeleteMelderHandler={addOrDeleteMelderHandler}
                                        reporterData={reporterData}
                                        isReporterLoading={isReporterLoading}
                                    />
                                )}

                                {openAfasSearchModal?.state && (
                                    <AfasGebruikerModal
                                        setModal={setOpenAfasSearchModal}
                                        modal={openAfasSearchModal}
                                        candidates={afasCandidateUsers}
                                        onAdd={addAfasUserHandler}
                                        isLoading={CoordinatorLoading || isReporterLoading || isAfasUsersLoading}
                                    />
                                )}
                            </div>

                            {/* Right Side */}
                            <div className="ms-auto d-flex align-items-center gap-3">
                                {activeTab === userTabs?.VrijeVelden && (
                                    <Button
                                        outline
                                        className="btn-outline-primary-blue btn-color-style besturen-footer-btn d-flex gap-2 align-items-center"
                                        onClick={handleSubmitForm}
                                        type="button"
                                        color="primary"
                                        disabled={disableSubmit}
                                    >
                                        Toepassen
                                    </Button>
                                )}
                            </div>
                        </div>
                    </CardFooter>
                </div>
            </div>

            <Modal
                isOpen={openModal}
                toggle={modalData?.type === "remove" ? undefined : toggle}
                className="feedback-modal-style overig-exporteren-modal-style modal-centered link-form"
            >
                <ModalHeader toggle={modalData?.type === "remove" ? undefined : toggle}>
                    {modalData?.type === "school" && "School toevoegen"}
                    {modalData?.type === "remove" && "Warning"}
                </ModalHeader>

                <ModalBody>
                    <Formik
                        enableReinitialize
                        initialValues={{ Naam: modalData?.vSchoolName ?? "", deleteConfirmation: "" }}
                        onSubmit={modalFormSubmitHandler}
                    >
                        {({ values, handleChange, handleSubmit }) => (
                            <Form onSubmit={handleSubmit}>
                                {(modalData?.type === "schoolSave" || modalData?.type === "schoolUpdate") && (
                                    <>
                                        <FormGroup className="d-flex justify-content-between">
                                            <Label for="Naam" className="mt-2">Naam</Label>
                                            <div style={{ width: '60%' }}>
                                                <Input
                                                    name="Naam"
                                                    type="text"
                                                    value={values.Naam}
                                                    onChange={(e) => {
                                                        handleChange(e);
                                                        setModalData(prev => {
                                                            return { ...prev, data: { ...prev.data, vSchoolName: e.target.value } };
                                                        })
                                                        if (e.target.value === modalData?.vSchoolName || e.target.value === '') {
                                                            setDisableModalSubmitButton(true);
                                                        } else {
                                                            setDisableModalSubmitButton(false);
                                                        }
                                                    }}
                                                />
                                                <ErrorMessage name="Naam" component="small" className="block mt-2 invalid-feedback" />
                                            </div>
                                        </FormGroup>
                                    </>
                                )}

                                {modalData?.type === "remove" && (
                                    <>
                                        <div className="travelCost-light-text">
                                            <p>
                                                <span className="travelCost-bold-text">NOTE:</span> You mark this organisation to remove all data.
                                            </p>
                                            <p>
                                                <span className="travelCost-bold-text">Text:</span> Type the word <strong>DELETE</strong> in the field below.
                                                The user must enter "DELETE" in the message box.
                                            </p>
                                            <p>After this, all data can be deleted via the Management Delete process.</p>
                                            <Input
                                                name="deleteConfirmation"
                                                placeholder="Type DELETE in hoofdletters ter bevestiging."
                                                value={values.deleteConfirmation}
                                                onChange={(e) => {
                                                    handleChange(e);
                                                    setModalData(prev => {
                                                        return { ...prev, data: e.target.value };
                                                    })
                                                    setDisableModalSubmitButton(e.target.value !== "DELETE");
                                                }}
                                            />
                                        </div>
                                    </>
                                )}

                                <ModalFooter className="d-flex align-items-center justify-content-center border-bottom-0 py-4 mt-4">
                                    <Button
                                        className="btn-color-style opslaan-btn"
                                        size="sm"
                                        outline
                                        color="primary"
                                        type="submit"
                                        disabled={disableModalSubmitButton}
                                    >
                                        Toepassen
                                    </Button>
                                    <Button
                                        className="btn-color-style opslaan-btn"
                                        size="sm"
                                        outline
                                        color="primary"
                                        onClick={toggle}
                                    >
                                        Annuleren
                                    </Button>
                                </ModalFooter>
                            </Form>
                        )}
                    </Formik>
                </ModalBody>
            </Modal>
        </Fragment >
    )
};

export default Besturens;